<template>
    <div class="col-md-12">

        <div class="h5">Customer journey customization</div>
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>

        <div class="mt-5">
            <div class="h4">External driver fees</div>
            <div>
                <table class="table table-bordered table-striped" aria-label="External driver fees table">

                    <tr>
                        <td style="width: 34%;">Cost prices for driver fees</td>
                        <td>
                            <div class="d-flex align-items-center mb-4">
                                <div class="address-type-label bold-font" style="width: 30%;">Empty value</div>
                                <div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <input
                                            class="form-control small-input mr-3"
                                            type="number"
                                            id="cost_price_empty"
                                            v-model="configurations[0]['driver_fees_cost_price_empty']"
                                        >
                                        <span>kr.</span>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.driver_fees_cost_price_empty`]">
                                        {{ errors[`configurations.driver_fees_cost_price_empty`][0] }}
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center mb-4">
                                <div class="address-type-label bold-font" style="width: 30%;">2-mands</div>
                                <div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <input
                                            class="form-control small-input mr-3"
                                            type="number"
                                            id="cost_price_2_mands"
                                            v-model="configurations[0]['driver_fees_cost_price_2_mands']"
                                        >
                                        <span>kr.</span>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.driver_fees_cost_price_2_mands`]">
                                        {{ errors[`configurations.driver_fees_cost_price_2_mands`][0] }}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>


                    <tr>
                        <td style="width: 34%;"><span class="bg-light-red p-1">Fees for external drivers</span></td>
                        <td>
                            <DriverFeesList
                                :items="(configurations[0]['driver_fees_fees_penalties'] || [])"
                                :errors="errors"
                                errorPrefix="configurations.0.driver_fees_fees_penalties"
                                addTitle="Add driver fee"
                                @add="addDriverFee"
                                @remove="removeDriverFee"
                                @update-item="onUpdatePenaltyItem"
                            />
                        </td>
                    </tr>

                    <tr>
                        <td style="width: 34%;"><span class="bg-light-green p-1">Bonuses for external drivers</span></td>
                        <td>
                            <DriverFeesList
                                :items="(configurations[0]['driver_fees_fees_bonuses'] || [])"
                                :errors="errors"
                                errorPrefix="configurations.0.driver_fees_fees_bonuses"
                                addTitle="Add driver bonus"
                                @add="addDriverBonus"
                                @remove="removeDriverBonus"
                                @update-item="onUpdateBonusItem"
                            />
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="mt-5">
            <button class="btn btn-primary" @click="save">Save configurations</button>
        </div>
    </div>

</template>

<script>
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue-select/dist/vue-select.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import DriverFeesList from './reusable/DriverFeesList.vue';
import moment from "moment/moment";
export default {
    name: "ConfigurationsExternalDriverFees",
    components: {VueTimepicker, DatePicker, DriverFeesList},
    mixins: [datePickerOptionsMixin],
    props: {
        configurationsProp: {type: Array, required: true},
    },
    data() {
        return {
            configurations: {
                0: {},
                3: {},
                4: {}
            },
            errors: {},

        }
    },
    created() {
        let value;
        for (let i in this.configurationsProp) {
            value = this.configurationsProp[i]['value'];

            if (this.configurationsProp[i]['name'].includes('driver_fees_fees_penalties')
            ) {
                value = value ? JSON.parse(value) : [];
            }
            if (this.configurationsProp[i]['name'].includes('driver_fees_fees_bonuses')
            ) {
                value = value ? JSON.parse(value) : [];
            }


            this.$set(
                this.configurations[this.configurationsProp[i]['booking_type']],
                this.configurationsProp[i]['name'],
                value
            );
        }

    },
    methods: {
        save() {
            this.errors = {};
            let data = JSON.parse(JSON.stringify(this.configurations));

            axios.post(`/configurations`, {configurations: data})
                .then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: `Saved successfully!`,
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                }).catch((err) => {
                this.flashError(err, ``);
            });
        },

        flashError(error) {
            let er = error.response.data || error.response;
            console.error(er);
            this.flashMessage.error({
                title: '',
                message: error.response.data.message || error.response.data ||  'Error',
                time: 3000,
                blockClass: 'flash-message error'
            });

            if (error.response.data.errors) {
                this.errors = error.response.data.errors;
            }
        },

        addDriverFee() {
            if (!this.configurations[0][`driver_fees_fees_penalties`]) {
                // Ensure the bonuses array exists; initialize if missing
                this.$set(this.configurations[0], `driver_fees_fees_penalties`, []);
            }

            this.configurations[0][`driver_fees_fees_penalties`].push({
                reason: '',
                price: 0,
                stk: '',
            });
        },

        addDriverBonus() {
            if (!this.configurations[0][`driver_fees_fees_bonuses`]) {
                // Ensure the bonuses array exists; initialize if missing
                this.$set(this.configurations[0], `driver_fees_fees_bonuses`, []);
            }
            this.configurations[0][`driver_fees_fees_bonuses`].push({
                reason: '',
                price: 0,
                stk: '',
            });
        },


        removeDriverFee(index) {
            this.configurations[0][`driver_fees_fees_penalties`].splice(index, 1);
        },

        removeDriverBonus(index) {
            this.configurations[0][`driver_fees_fees_bonuses`].splice(index, 1);
        },

        onUpdatePenaltyItem({ index, field, value }) {
            if (!this.configurations[0][`driver_fees_fees_penalties`]) {
                this.$set(this.configurations[0], `driver_fees_fees_penalties`, []);
            }
            const arr = this.configurations[0][`driver_fees_fees_penalties`];
            if (!arr[index]) return;
            this.$set(arr[index], field, value);
        },

        onUpdateBonusItem({ index, field, value }) {
            if (!this.configurations[0][`driver_fees_fees_bonuses`]) {
                this.$set(this.configurations[0], `driver_fees_fees_bonuses`, []);
            }
            const arr = this.configurations[0][`driver_fees_fees_bonuses`];
            if (!arr[index]) return;
            this.$set(arr[index], field, value);
        },
    }
}
</script>

<style scoped>
.time-picker input {
    margin-left: 0;
}

tr th:not(:first-child),
tr td:not(:first-child) {
    text-align: center;
}

.small-input {
    max-width: 140px;
}



.address-type-label {
    min-width: 60px;
    text-align: left;
}

.bold-font {
    font-weight: bold;
    font-size: 1.1rem;
}

</style>
